// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CiscoIntegrationTextingInternalEndpointsRequest {
    'userName': string;
    'phoneNumber': string;
    'shortCode': string;
    'message': string;
    'memberNumber': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CiscoIntegrationTextingInternalEndpointsRequest>> = [
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "shortCode",
            "baseName": "shortCode",
            "type":     "string"
        },
        {
            "name":     "message",
            "baseName": "message",
            "type":     "string"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CiscoIntegrationTextingInternalEndpointsRequest.attributeTypeMap;
    }
}
